export const assertNever = (message: never): never => {
  throw new Error(message);
};